module.exports = __webpack_public_path__ + "static/load-world-7828baf0eb8c48655f858627bf997b7b.png";